// extracted by mini-css-extract-plugin
export default {"input":"linkStyles_input__wMlyr","inputInvalid":"linkStyles_inputInvalid__x+Wsv","link":"linkStyles_link__HHQf2"};